import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/manual_trading',
  component: Layout,
  redirect: '/manual_trading/index',
  name: 'manualTrading',
  meta: {
    title: '手动交易',
    i18n: 'route.tabbar',
    icon: 'game-icons:3d-glasses',
  },
  children: [
    {
      path: 'index',
      name: 'manualTradingIndex',
      component: () => import('@/views/manual_trading/index.vue'),
      meta: {
        title: '手动交易',
        i18n: 'route.tabbar',
      },
    },
    {
      path: 'gruop',
      name: 'manualTradingGruop',
      component: () => import('@/views/manual_trading/gruop.vue'),
      meta: {
        title: '用户组',
        i18n: 'route.tabbar',
      },
    },
  ],
}

export default routes
